class MagNav {
    constructor($content, $headings) {
        if (!$content || !$headings) {
            throw new Error('MagNav requires parameters');
        }

        this.options = {
            bar: 'magnet-bar',
            item: 'magnet-item',
            active: 'magnet-item-active',
            top: 'magnet-top',
            fixed: 'magnet-bar-fixed'
        };

        this.navItemCount = 0;

        this.$content = $content;
        this.$headings = $headings;
        this.$navList = document.createElement('ul');
        this.$top = document.createElement('div');
        this.$top.id = this.options.top;
        this.$backToTopLinks = [];

        this.$navList.classList.add(this.options.bar);

        this.$headings.forEach($heading => {
            const id = `magnet-${this.navItemCount++}`,
                $navListItem = document.createElement('li'),
                $navLink = document.createElement('a'),
                $backToTopContainer = document.createElement('div'),
                $backToTopLink = document.createElement('a');

            $backToTopLink.textContent = 'back to top';
            $backToTopLink.href = `#${this.options.top}`;
            $backToTopContainer.classList.add(this.options.top);
            $backToTopContainer.appendChild($backToTopLink);
            $heading.parentElement.appendChild($backToTopContainer);

            this.$backToTopLinks.push($backToTopContainer);

            $navLink.href = `#${id}`;
            $navLink.textContent = $heading.textContent;
            $navListItem.classList.add(this.options.item);

            $navListItem.appendChild($navLink);
            this.$navList.appendChild($navListItem);

            $heading.id = id;

            $navLink.addEventListener('click', event => {
                event.preventDefault();
                const $destination = document.getElementById(event.target.getAttribute('href').substring(1));

                if ($destination && $destination.scrollIntoView) {
                    $destination.scrollIntoView({block: 'start', behavior: 'smooth'});
                }

                [...this.$navList.querySelectorAll(`.${this.options.active}`)].forEach($active =>
                    $active.classList.remove(this.options.active)
                );

                event.target.classList.add(this.options.active);
            });
        });

        document.body.insertBefore(this.$top, document.body.firstElementChild);
        this.$content.insertAdjacentElement('beforebegin', this.$navList);

        this.top = this.$navList.getBoundingClientRect().top + window.scrollY;

        this.handleScroll = () => {
            requestAnimationFrame(() => {
                if (window.scrollY >= this.top) {
                    if (!this.$navList.classList.contains(this.options.fixed)) {
                        this.$navList.classList.add(this.options.fixed);
                    }

                    return;
                }

                if (this.$navList.classList.contains(this.options.fixed)) {
                    this.$navList.classList.remove(this.options.fixed);
                }
            });
        };

        window.addEventListener('scroll', this.handleScroll);
    }

    destroy() {
        this.$headings.forEach($heading => {
            $heading.removeAttribute('id');
        });
        this.$backToTopLinks.forEach($link => $link.parentElement.removeChild($link));
        this.$navList.parentElement.removeChild(this.$navList);
        this.$top.parentElement.removeChild(this.$top);
        window.removeEventListener('scroll', this.handleScroll);
    }
}

export default MagNav;
